export default {"src":"/_next/static/media/nordic_skiing.5b28bc4c.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};